<template>
  <div>
    <Breadcrumb :dataSource="breadcrumbList" />
    <div class="page-container" style="padding-top: 0">
      <a-tabs :default-active-key="tabKey" @change="handleTabChange">
        <a-tab-pane v-for="item in tabPaneConfig" :key="item.key" :tab="item.tab">
          <div class="flex-between">
            <a-radio-group v-model="dataType" style="margin: 6px 0" @change="changeRadio">
              <a-radio-button
                v-for="(cItem, index) in catchTypeList"
                :key="index"
                :value="cItem.value"
              >
                {{ cItem.label }}
              </a-radio-button>
            </a-radio-group>
            <div>
              <a-popconfirm
                v-if="identityId == 1"
                title="确定要一键提醒心理老师吗？"
                ok-text="确认"
                cancel-text="取消"
                @confirm="oneKeyUrgeDo"
              >
                <a-button type="primary" :loading="btnLoading" style="margin-right: 15px">
                  一键提醒心理老师
                </a-button>
              </a-popconfirm>
              <a-button
                icon="download"
                :loading="exportXlsLoading"
                @click="handleExportXls(`${item.tab}-${catchObj.label}`)"
              >
                导出
              </a-button>
            </div>
          </div>
          <TableList
            :columns="columns"
            :tableData="dataSource"
            bordered
            :loading="loading"
            :scroll="{x:'max-content'}"
            :pagination="ipagination"
            @change="handleTableChange"
            style="min-height: 350px"
          >
            <div slot="queryArea" class="query-area">
              <j-dict-select-tag
                style="width: 170px; margin-right: 15px"
                placeholder="请选择年级"
                v-model="queryParam.gradeId"
                dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
                :isShowEmpty="false"
                @select="$set(queryParam, 'classId', undefined)"
                @clear="$set(queryParam, 'classId', undefined)"
              />
              <j-dict-select-tag
                style="width: 170px; margin-right: 15px"
                placeholder="请选择班级"
                v-model="queryParam.classId"
                :dictCode="
                  'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
                "
                :async="true"
                :disabled="!queryParam.gradeId"
                :isShowEmpty="false"
              />
              <a-range-picker
                v-model="dateRange"
                class="search-space"
                style="width: 240px"
                @change="changeDateRange"
              />
              <j-dict-select-tag
                v-model="queryParam.care"
                placeholder="关爱等级"
                dictCode="care_list"
                class="search-space"
              />
              <a-input-search
                v-model="queryParam.studentName"
                placeholder="请输入学生名字"
                class="search-space"
                style="width: 170px"
                @change="searchName"
              />
              <a-button type="primary" @click="searchQuery">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 15px">
                重置
              </a-button>
            </div>
            <div class="flex-align-center" slot="labelsList" slot-scope="{ record }">
              <span
                v-for="(item, index) in record.labelsList"
                :key="index"
                :style="{
                  color: getStuTagColorConfig(item.key).color,
                  background: getStuTagColorConfig(item.key).bgColor,
                }"
                class="label-item"
              >
                {{ item.text }}
              </span>
            </div>
            <span slot="hasWarnThisWeek" slot-scope="{ record }">
              <img
                v-if="record.hasWarnThisWeek == '1'"
                src="@/assets/imgs/commonPage/remind.png"
                alt=""
                style="width: 20px; height: 20px"
              />
              <span v-else>未提醒</span>
            </span>
            <template slot="action" slot-scope="{ record }">
              <div class="action-detail">
                <!--心理老师端操作-->
                <template v-if="identityId == 6">
                  <!-- 
                      record.warnStatus == 2
                      ? '未确认预约'
                      : record.warnStatus >= 3 && record.warnStatus < 5
                      ? '未辅导'
                      : record.warnStatus >= 5 && record.warnStatus < 7
                      ? '已辅导'
                      : '-'
                  -->
                  <!--未确认预约时显示-->
                  <a-popconfirm
                    v-if="record.warnStatus == 2"
                    title="是否确认预约"
                    @confirm="confirmReservation(record)"
                    @cancel="() => {}"
                  >
                    <span style="color: #0077fa">确认预约</span>
                  </a-popconfirm>
                  <span v-else style="color: rgba(23, 144, 255, 0.5);cursor:no-drop;">已确认预约</span>
                  <a-divider type="vertical" />
                  <!--未辅导时显示-->
                  <span
                    v-if="record.warnStatus != 2 && record.warnStatus >= 3 && record.warnStatus < 5"
                    :style="{
                      color: '#0077fa',
                    }"
                    @click="mentoringRecord(record)"
                  >
                    辅导记录
                  </span>
                  <span
                    v-else
                    style="
                      color:rgba(23, 144, 255, 0.5);
                      cursor:no-drop
                    "
                  >
                    辅导记录
                  </span>
                  <a-divider type="vertical" />
                  <span @click="homeSchoolCom(record)">家校沟通</span>
                  <a-divider type="vertical" />
                </template>
                <span @click="viewArchives(record)">查看档案</span>
              </div>
            </template>
          </TableList>
        </a-tab-pane>
      </a-tabs>
      <MentoringRecordModal ref="mentoringRecordModalRef" @refreshData="loadData" />
      <SchoolHomeComModal ref="schoolHomeComModalRef" />
    </div>
  </div>
</template>
<script>
import TableList from '@/components/chart/TableList'
import { getAction, postAction } from '@api/manage'
import { getDictCodeData, simpleDebounce, getStuTagColorConfig } from '@/utils/util'
import AssessModal from '@/comUi/AssessModal'
import moment from 'moment'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import Breadcrumb from '@/components/Breadcrumb/index'
import MentoringRecordModal from '@/comUi/MentoringRecordModal.vue'
import SchoolHomeComModal from '@/comUi/SchoolHomeComModal.vue'
import { mapGetters } from 'vuex'
import { getSchoolTerm } from '@/utils/termDate'
import { getWeekDateRange, getMonthDateRange, formatYearMonthDate } from '@/utils/date'

export default {
  name: 'PsyCounselAppointment',
  components: {
    Breadcrumb,
    TableList,
    AssessModal,
    MentoringRecordModal,
    SchoolHomeComModal,
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      breadcrumbList: [
        {
          label: '心理工作概览',
          isBack: true,
        },
        {
          label: '心理辅导预约',
        },
      ],
      tabKey: 0,
      dataType: 0,
      dateRange: [],
      catchTypeList: [
        {
          label: '全部',
          value: 0,
        },
        {
          label: '已辅导',
          value: 2,
        },
        {
          label: '未辅导',
          value: 1,
        },
        {
          label: '未确认预约',
          value: 4,
        },
      ],
      // tab列表配置
      tabPaneConfig: [
        {
          tab: '班主任预约',
          key: 1,
        },
        {
          tab: '家长预约',
          key: 2,
        },
      ],
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          fixed:"left",
          align: 'center',
          width:50,
        },
        {
          title: '姓名',
          dataIndex: 'studentName',
          align: 'center',
          fixed:"left",
          width:100,
        },
        {
          title: '班级',
          dataIndex: 'className',
          align: 'center',
          width:100,
        },
        {
          title: '学生标签',
          dataIndex: 'labelsList',
          align: 'center',
          scopedSlots: { customRender: 'labelsList' },
        },
        // {
        //   title: '关爱等级',
        //   dataIndex: 'care_dictText',
        // },
        {
          title: '辅导时间',
          width:150,
          dataIndex: 'careTime',
        },
        {
          title: '辅导类型',
          width:100,
          dataIndex: 'tutoringType_dictText',
        },
        {
          title: '辅导方法',
          width:100,
          dataIndex: 'tutoringMethod_dictText',
        },
        {
          title: '问题原因',
          width:100,
          dataIndex: 'psychologyIssues_dictText',
        },
        {
          title: '下一步措施',
          width:200,
          dataIndex: 'nextIntervention_dictText',
        },
        {
          title: '效果反馈',
          width:100,
          dataIndex: 'effectFeedback_dictText',
        },
        {
          title: '危机等级',
          width:100,
          dataIndex: 'crisisLevel_dictText',
        },
        {
          title: '具体情况说明',
          dataIndex: 'remark',
          width:500,
        },
        {
          title: '心理老师',
          dataIndex: 'name',
          width:100,
        },
        {
          title: '处理时间',
          dataIndex: 'createTime',
          width:150,
        },
        {
          title: '处理状态',
          width:80,
          dataIndex: 'warnStatus',
          align: 'center',
          customRender: (_, record) => {
            return record.warnStatus == 2
              ? '未确认预约'
              : record.warnStatus >= 3 && record.warnStatus < 5
              ? '未辅导'
              : record.warnStatus >= 5 && record.warnStatus < 7
              ? '已辅导'
              : '-'
          },
        },
        {
          title: '本周提醒',
          dataIndex: 'hasWarnThisWeek',
          align: 'center',
          width:50,
          scopedSlots: { customRender: 'hasWarnThisWeek' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width:350,
          fixed:"right",
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/statisticV2/getAppointmentRecord',
        exportXlsUrl: '/statisticV2/exportAppointmentRecordXls',
      },
      disableMixinCreated: true,
      btnLoading: false,
    }
  },
  created() {
    const currTabKey = this.$route.query?.index
    const currTimeType = this.$route.query?.timeType
    this.setDate()
    
    if (currTabKey) {
      this.tabKey = Number(currTabKey)
    }
    

    this.queryParam.type = this.tabKey
    this.queryParam.dataType = this.dataType
    this.queryParam.userIdentity = this.identityId
    this.loadData(1)
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
    catchObj() {
      return this.catchTypeList.find((item) => item.value == this.dataType)
    },
    ...mapGetters(['identityId']),
  },
  methods: {
    setDate(){
      const beginDateQuery = this.$route.query?.beginDate
      const endDateQuery = this.$route.query?.endDate
      if (beginDateQuery && endDateQuery) {
        this.dateRange = [formatYearMonthDate(beginDateQuery), formatYearMonthDate(endDateQuery)]
        this.queryParam.beginDate = this.dateRange[0]
        this.queryParam.endDate = this.dateRange[1]
      } else if (currTimeType === 'week' || currTimeType === 'month') {
        this.dateRange = [moment().startOf(currTimeType), moment().endOf(currTimeType)]
        this.queryParam.beginDate = this.dateRange[0].format('YYYY-MM-DD')
        this.queryParam.endDate = this.dateRange[1].format('YYYY-MM-DD')
      } else if (currTimeType === 'term') {
        this.queryParam.beginDate = getSchoolTerm().startDate
        this.queryParam.endDate = getSchoolTerm().endDate
      }
    },
    getStuTagColorConfig,
    handleTabChange(key) {
      this.queryParam = {
        userIdentity: this.identityId,
        beginDate: this.dateRange[0],
        endDate: this.dateRange[1],
      }
      this.tabKey = key
      this.queryParam.type = key
      this.dataType = 0
      this.queryParam.dataType = 0
      this.loadData(1)
    },
    changeRadio(e) {
      this.dataType = e.target.value
      this.queryParam.dataType = this.dataType
      this.loadData(1)
    },
    changeDateRange(dateArr) {
      this.queryParam.beginDate = dateArr?.[0] && moment(dateArr[0]).format('YYYY-MM-DD')
      this.dateRange[0] = dateArr?.[0] && moment(dateArr[0]).format('YYYY-MM-DD')
      this.queryParam.endDate = dateArr?.[1] && moment(dateArr[1]).format('YYYY-MM-DD')
      this.dateRange[1] = dateArr?.[1] && moment(dateArr[1]).format('YYYY-MM-DD')
    },
    searchName: simpleDebounce(function (event) {
      this.queryParam.studentName = event.target?.value?.trim()
      this.loadData(1)
    }, 800),
    // 重置
    searchReset() {
      this.dateRange = []
      // this.queryParam.beginDate = this.dateRange[0].format('YYYY-MM-DD')
      // this.queryParam.endDate
      this.queryParam = {
        userIdentity: this.identityId,
        beginDate:'',
        endDate:''
      }
      this.queryParam.type = this.tabKey
      this.queryParam.dataType = this.dataType
      this.loadData(1)
    },
    viewArchives(record) {
      this.$router.push({
        path: '/school/mentalHealth/ArchivesViewPage',
        query: {
          studentId: record.studentId,
        },
      })
    },
    async oneKeyUrgeDo() {
      this.btnLoading = true
      const res = await postAction('/statisticV2/getAppointmentRecordPush', {
        type: this.tabKey,
      })
      this.btnLoading = false
      const { success } = res
      if (success) {
        this.$message.success('一键提醒心理老师成功')
        return
      }
      this.$message.success('一键提醒心理老师失败')
    },
    mentoringRecord(record) {
      // if (record?.warnStatus == 3 || record?.warnStatus == 4) {
      //   this.$refs.mentoringRecordModalRef.showModal(record)
      // }
      this.$refs.mentoringRecordModalRef.showModal(record)
    },
    homeSchoolCom(record) {
      this.$refs.schoolHomeComModalRef.showModal(record)
    },
    async confirmReservation(record) {
      const res = await postAction('/aigoes/schoolWarnRecord/warnProcess', {
        id: record.id,
        warnStatus: 3,
        comment: '已确认预约',
        visible: 1,
      })
      if (res.success) {
        this.$message.success('确认预约成功')
        this.loadData()
        return
      }
      this.$message.error('确认预约失败')
    },
  },
}
</script>
<style scoped lang="less">
.query-area {
  margin-bottom: 20px;
}
.action-detail {
  min-width: 100px !important;
  color: #0077fa !important;
  cursor: pointer !important;
  white-space:normal;
}
.search-space {
  width: 140px;
  margin-right: 15px;
}
.label-item {
  margin: 0 4px;
  padding: 2px 8px;
  color: #575757;
  background-color: #fafafa;
  border-radius: 12px;
  white-space: normal;
}
/deep/ .ant-table td { white-space: break-spaces; }

</style>
